// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const DELETION_OF_PHOTOBLOG_COMMENT = "Ma\u017eem koment\u00e1r";
export const DELETION_OF_PHOTOBLOG_POST = "Ma\u017eem pr\u00edspevok";
